import React from 'react'
import {
  TextField as MuiTextField,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Box,
  Typography,
  Grid,
  Select,
  MenuItem,
  InputLabel,
} from '@mui/material'
import { StadsprognoseFormData, StadsprognoseConfig } from '../../../types/stadsprognoseTypes'

interface Props {
  formData: StadsprognoseFormData
  onChange: (updates: Partial<StadsprognoseFormData>) => void
  config: StadsprognoseConfig | null
}

const afrondenOptions = [
  { value: '0', label: 'Zoals Gbpro afronden' },
  { value: '1', label: 'Niet afronden' },
  { value: '2', label: 'Alleen geboorte en sterfte afronden' },
  { value: '3', label: 'Alleen geboorte afronden' },
  { value: '4', label: 'Alleen sterfte afronden' },
]

const Step1Basis: React.FC<Props> = ({ formData, onChange, config }) => {
  return (
    <Box>
      <Typography variant="h6" gutterBottom>Basisinstellingen</Typography>
      <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
        Alle velden (m.u.v. omschrijving) zijn verplicht.
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <MuiTextField
            fullWidth
            label="Naam stadsprognose"
            value={formData.naam}
            onChange={(e) => onChange({ naam: e.target.value })}
            required
          />
        </Grid>

        <Grid item xs={12}>
          <MuiTextField
            fullWidth
            label="Korte omschrijving"
            value={formData.omschrijving}
            onChange={(e) => onChange({ omschrijving: e.target.value })}
            multiline
            rows={2}
          />
        </Grid>

        <Grid item xs={6}>
          <MuiTextField
            fullWidth
            label="Beginjaar (BJAAR)"
            type="number"
            value={formData.bjaar}
            onChange={(e) => onChange({ bjaar: parseInt(e.target.value, 10) })}
            helperText={config?.max_bjaar ? `Max: ${config.max_bjaar}` : ''}
            inputProps={{
              max: config?.max_bjaar,
            }}
          />
        </Grid>

        <Grid item xs={6}>
          <MuiTextField
            fullWidth
            label="Eindjaar (EJAAR)"
            type="number"
            value={formData.ejaar}
            onChange={(e) => onChange({ ejaar: parseInt(e.target.value, 10) })}
          />
        </Grid>

        <Grid item xs={12}>
          <FormControl>
            <FormLabel>Selecteer Bron</FormLabel>
            <RadioGroup
              row
              value={formData.bron}
              onChange={(e) => onChange({ bron: e.target.value })}
            >
              <FormControlLabel value="cbs" control={<Radio />} label="Cbs" />
              {config?.has_import_data && (
                <FormControlLabel value="import" control={<Radio />} label="Import" />
              )}
            </RadioGroup>
          </FormControl>
        </Grid>

        <Grid item xs={6}>
          <FormControl>
            <FormLabel>Selecteer berekenmethode sterftekans</FormLabel>
            <RadioGroup
              row
              value={formData.calc_method_stk}
              onChange={(e) => onChange({ calc_method_stk: e.target.value })}
            >
              <FormControlLabel value="model" control={<Radio />} label="Model" />
              <FormControlLabel value="gbpro" control={<Radio />} label="Gbpro" />
            </RadioGroup>
          </FormControl>
        </Grid>

        <Grid item xs={6}>
          <FormControl>
            <FormLabel>Selecteer berekenmethode salit</FormLabel>
            <RadioGroup
              row
              value={formData.calc_method_salit}
              onChange={(e) => onChange({ calc_method_salit: e.target.value })}
            >
              <FormControlLabel value="hsr" control={<Radio />} label="Hsr" />
              <FormControlLabel value="none" control={<Radio />} label="Stuurkaart" />
            </RadioGroup>
          </FormControl>
        </Grid>

        <Grid item xs={12}>
          <FormControl fullWidth size="small">
            <InputLabel>Selecteer methode voor afronden</InputLabel>
            <Select
              value={formData.afronden}
              label="Selecteer methode voor afronden"
              onChange={(e) => onChange({ afronden: e.target.value })}
            >
              {afrondenOptions.map((opt) => (
                <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    </Box>
  )
}

export default Step1Basis
